import React, { Component } from 'react';

class Thead extends Component {

	render() {

		const className = this.props.className ? 'thead ' + this.props.className : 'thead';

		return (
			<div className={className}>
				{this.props.children}
			</div>
		);
	}
}

export default Thead;
